import { RIDER_FOOD_CONSUMER_VOCABULARIES } from './rider-food-consumer.js';
/** Slice d592 of the catalog (D577): the vocabularies the rider app's food screens (D592) brought. */
export const SLICE_D592 = [...RIDER_FOOD_CONSUMER_VOCABULARIES];
//# sourceMappingURL=slice-d592.js.map